import { GeneratedAsset, CopyButton } from "./GeneratedAsset";
import VideoPanel from "./VideoPanel";

function Column({ label, note, frame, hero, onGenerate, video, onVideo, model, prompt, id }) {
  return (
    <div className="card fade-up" data-testid={`spa-variant-${id}`} style={{ padding: 28 }}>
      <div className="eyebrow">{label}</div>
      <p style={{ margin: "8px 0 0", fontSize: 13, color: "var(--ink-60)", lineHeight: 1.55 }}>{note}</p>
      <div style={{ display: "flex", gap: 20, marginTop: 20, alignItems: "flex-start" }}>
        {frame && <GeneratedAsset asset={frame} onGenerate={onGenerate} width={200} />}
        {hero && <GeneratedAsset asset={hero} onGenerate={onGenerate} width={240} ratio="3 / 2" />}
      </div>
      {prompt && (
        <details style={{ marginTop: 16 }}>
          <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 600 }}>Variant video prompt</summary>
          <p data-testid={`clip-prompt-${id}`} style={{ margin: "8px 0 0", fontSize: 13, lineHeight: 1.6, background: "var(--porcelain)", borderRadius: 12, padding: 14, border: "1px solid var(--ink-06)" }}>{prompt}</p>
          <div style={{ marginTop: 8 }}><CopyButton text={prompt} id={id} /></div>
        </details>
      )}
      <VideoPanel video={video} frameReady={!!frame?.url} onGenerate={onVideo} model={model} />
    </div>
  );
}

export default function SpaComparison({ clip, frames, videos, onGenerate, onVideo, model }) {
  if (!clip?.variant) return null;
  return (
    <div style={{ marginTop: 56 }}>
      <div className="eyebrow">Clip 3 · spa style comparison</div>
      <h3 className="serif" style={{ fontSize: 34, fontWeight: 500, margin: "6px 0 0", lineHeight: 1.1 }}>Warm minimalist vs. SoHo loft-modern</h3>
      <p style={{ maxWidth: 640, fontSize: 14, lineHeight: 1.65, color: "var(--ink-60)", marginTop: 12 }}>
        Same manager, same blank tablet, same dolly-in — only the Aura interior changes. Use the picker above to lock one; the S3 hero, Clip 3 and the rough cut follow.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginTop: 24 }}>
        <Column id="warm" label="A · Warm minimalist (current)" note="Porcelain limewash, pale oak, blush linen, eucalyptus. Reads closest to the brand palette; end card feels continuous."
          frame={frames.clip3_frame} hero={frames.aura_hero_warm} video={videos.clip3} onGenerate={onGenerate} onVideo={onVideo} model={model} />
        <Column id="loft" label="B · SoHo loft-modern" note="Concrete, black steel, greenery, brass, one burgundy velvet bench. More Manhattan-identifiable; contrast against porcelain UI is stronger."
          frame={frames.clip3_frame_loft} hero={frames.aura_hero_loft} video={videos.clip3_loft} onGenerate={onGenerate} onVideo={onVideo} model={model} prompt={clip.variant.video_prompt} />
      </div>
    </div>
  );
}
